import { useQuery } from '@tanstack/react-query';
import { PostFilterDto } from 'src/api/FiretrolApiClient';
import { postApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry First page of a job's unresolved posts, for the Operations dashboard feed. */
export function usePostSearchForOperations(
  jobId: number | null | undefined,
  filters: PostFilterDto,
) {
  return useQuery({
    queryKey: queryKeys.posts.search(jobId ?? -1, { filters, page: 1 }),
    queryFn: ({ signal }) =>
      postApiClient.searchPosts(
        jobId!,
        { filters },
        'updated_at',
        'all',
        '',
        1,
        toCancelToken(signal),
      ),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'operations activity feed' },
  });
}
